// إصلاح مشكلة المسافة في حقل البحث - جميع الصفحات
document.addEventListener('DOMContentLoaded', function() {
    // إصلاح فوري للمسافة
    setTimeout(function() {
        fixSpaceIssue();
    }, 100);
    
    // إصلاح إضافي للصفحة الرئيسية
    setTimeout(function() {
        fixSpaceIssue();
    }, 1000);
});

function fixSpaceIssue() {
    // جميع أنواع حقول البحث
    const searchInputs = document.querySelectorAll(
        '.search-input, .yv-search-bar, #search-drawer-input-query, [data-search-input], input[name="q"]'
    );
    
    searchInputs.forEach(function(input) {
        // إزالة جميع مستمعي الأحداث التي تمنع المسافة
        const newInput = input.cloneNode(true);
        input.parentNode.replaceChild(newInput, input);
        
        // مستمع جديد يسمح بالمسافات تماماً
        newInput.addEventListener('keydown', function(e) {
            // عدم منع أي مفتاح بما في ذلك المسافة
            if (e.which === 32 || e.keyCode === 32) {
                e.stopPropagation();
                return true; // السماح صراحة بالمسافة
            }
        });
        
        // إعادة ربط وظيفة البحث
        newInput.addEventListener('keyup', function(e) {
            if (typeof searchTyping !== 'undefined') {
                clearTimeout(searchTyping);
            }
            if (typeof searchResults === 'function') {
                var _this = $(this);
                searchResults(_this);
            }
        });
    });
}

// إصلاح خاص للصفحة الرئيسية
if (window.location.pathname === '/' || document.body.classList.contains('template_index')) {
    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(fixSpaceIssue, 2000); // تأخير إضافي للصفحة الرئيسية
    });
}

// دالة بديلة للبحث تسمح بالمسافات
function fixedSearchHandler() {
    $('body').off('keydown', '.search-input'); // إزالة المستمع القديم
    
    $('body').on('keydown', '.search-input', function(e) {
        clearTimeout(searchTyping);
        // عدم منع المسافة نهائياً
        // السماح بجميع المفاتيح
    });
}

// تشغيل الإصلاح
$(document).ready(function() {
    fixedSearchHandler();
});